import { MenuItem } from "@atsystems/ui";
import { Roles } from "src/app/common/helpers/roles";

export const DEFAULT_MENU_ITEMS: MenuItem[] = [
  {
    id: 'tracker',
    label: 'Tracker',
    icon: 'i i-chart-bar',
    expanded: false,
    route: 'tracker-v2',
    roles: Roles.TRACKER_VIEWER,
  },
  {
    id: 'bundles-list',
    label: 'Bundles list',
    icon: 'i i-server',
    route: 'bundles-v2',
    expanded: false,
    roles: Roles.BUNDLES_LIST_VIEWER,
  },
  {
    id: 'split-tests',
    label: 'Split Tests',
    icon: 'i i-clone',
    route: 'splits',
    expanded: false,
    roles: Roles.SPLITS_VIEWER,
  },{
    id: 'networks',
    label: 'Networks',
    icon: 'i i-sitemap',
    route: 'networks-v2',
    expanded: false,
    roles: Roles.NETWORKS_VIEWER,
  },{
    id: 'sources',
    label: 'Sources',
    icon: 'i i-code',
    route: 'sources-v2',
    expanded: false,
    roles: Roles.SOURCES_VIEWER,
  },
];
